import {configParamsModule} from "./configParamsModule"
import {IStateProvider} from "angular-ui-router";

configParamsModule.config(($stateProvider: IStateProvider) => {
    $stateProvider.state("r2.configParams", {
        data: {
            pageTitle: "{{'title.configuration.server' | translate}}",
            group: "group.r2.configuration.advanced"
        },
        url: "/configParams",
        template: require("./configParamsView.html"),
        controller: "configParamsController",
        controllerAs: "ctrl",
    }).state("r2.configParamsPermissionGroupDetails", {
        data: {
            pageTitle: "{{'permissionGroupDetails.title' | translate}}",
            group: "group.r2.configuration.advanced"
        },
        url: "/permission-group-details/:permissionGroupId",
        template: require("./permissionGroup/details/permissionGroupDetails.html"),
        controller: "permissionGroupDetailsController",
        controllerAs: "ctrl",
        resolve: {
            permissionGroup: ["$stateParams", "permissionGroupDetailsService", "$state", function ($stateParams, permissionGroupDetailsService, $state) {
                return permissionGroupDetailsService.findPermissionGroupById($stateParams.permissionGroupId).then(function (permissionGroup) {
                    if (!permissionGroup) {
                        return $state.go("r2.permissionGroups")
                    }
                    return permissionGroup
                })
            }]
        }
    }).state("r2.permissionGroups", {
        data: {
            pageTitle: "{{'menu.administration.permissionGroups' | translate}}",
            group: "group.r2.configuration.advanced"
        },
        url: "/permission-groups",
        template: require("./permissionGroup/administration/permissionGroupAdministration.html"),
        controller: "permissionGroupAdministrationController",
        controllerAs: "ctrl"
    }).state("r2.configParamsPermissionGroupSupport", {
        data: {
            pageTitle: "{{'permissionGroupDetails.title' | translate}}",
            group: "group.r2.configuration.permission.group.support"
        },
        url: "/permission-group-support",
        template: require("./permissionGroup/support/permissionGroupSupport.html"),
        controller: "permissionGroupSupportController",
        controllerAs: "ctrl",
        resolve: {
            permissionGroup: ["permissionGroupSupportService", "$state", function (permissionGroupSupportService, $state) {
                return permissionGroupSupportService.getAuthenticated().then(function (permissionGroup) {
                    if (!permissionGroup) {
                        return $state.go("r2.permissionGroups")
                    }
                    return permissionGroup
                })
            }]
        }
    }).state("r2.configMicrostrategy", {
        data: {
            pageTitle: "{{'microstrategy.title' | translate}}",
            group: "group.r2.configuration.permission.group.support.manager"
        },
        url: "/config-microstrategy",
        template: require("./permissionGroup/microstrategy-configuration/microstrategyConfiguration.html"),
        controllerAs: "ctrl"
    })
})